import {
  GET_TRAININGSUBJECTS,
  GET_TRAININGSUBJECTS_SUCCESS,
  GET_TRAININGSUBJECTS_FAIL,
  GET_TRAININGTYPES,
  GET_TRAININGTYPES_SUCCESS,
  GET_TRAININGTYPES_FAIL,
  GET_TRAININGMONTHS,
  GET_TRAININGMONTHS_SUCCESS,
  GET_TRAININGMONTHS_FAIL,
  GET_HOUSEHOLD_DETAIL,
  GET_HOUSEHOLD_DETAIL_SUCCESS,
  GET_HOUSEHOLD_DETAIL_FAIL,
  GET_HOUSEHOLDS,
  GET_HOUSEHOLDS_SUCCESS,
  GET_HOUSEHOLDS_FAIL,
  ADD_HOUSEHOLD,
  ADD_HOUSEHOLD_SUCCESS,
  ADD_HOUSEHOLD_FAIL,
  UPDATE_HOUSEHOLD,
  UPDATE_HOUSEHOLD_SUCCESS,
  UPDATE_HOUSEHOLD_FAIL,
  ADD_HOUSEHOLD_FILEUPLOAD,
  ADD_HOUSEHOLD_FILEUPLOAD_SUCCESS,
  ADD_HOUSEHOLD_FILEUPLOAD_FAIL,
  ADD_HOUSEHOLD_DATAUPLOAD,
  ADD_HOUSEHOLD_DATAUPLOAD_SUCCESS,
  ADD_HOUSEHOLD_DATAUPLOAD_FAIL,
  ADD_SUBJECT,
  ADD_SUBJECT_SUCCESS,
  ADD_SUBJECT_FAIL,
  UPDATE_SUBJECT,
  UPDATE_SUBJECT_SUCCESS,
  UPDATE_SUBJECT_FAIL,
  GET_SUBJECT_DETAIL,
  GET_SUBJECT_DETAIL_SUCCESS,
  GET_SUBJECT_DETAIL_FAIL,
} from "./actionTypes"

export const getHouseholds = () => ({
  type: GET_HOUSEHOLDS,
})

export const getHouseholdsSuccess = households => ({
  type: GET_HOUSEHOLDS_SUCCESS,
  payload: households,
})

export const getHouseholdsFail = error => ({
  type: GET_HOUSEHOLDS_FAIL,
  payload: error,
})

export const getHouseholdDetail = rowID => ({
  type: GET_HOUSEHOLD_DETAIL,
  rowID,
})

export const getHouseholdDetailSuccess = details => ({
  type: GET_HOUSEHOLD_DETAIL_SUCCESS,
  payload: details,
})

export const getHouseholdDetailFail = error => ({
  type: GET_HOUSEHOLD_DETAIL_FAIL,
  payload: error,
})

export const addHousehold = household => ({
  type: ADD_HOUSEHOLD,
  payload: household,
})

export const addHouseholdSuccess = household => ({
  type: ADD_HOUSEHOLD_SUCCESS,
  payload: household,
})

export const addHouseholdFail = error => ({
  type: ADD_HOUSEHOLD_FAIL,
  payload: error,
})

export const updateHousehold = household => ({
  type: UPDATE_HOUSEHOLD,
  payload: household,
})

export const updateHouseholdSuccess = household => ({
  type: UPDATE_HOUSEHOLD_SUCCESS,
  payload: household,
})

export const updateHouseholdFail = error => ({
  type: UPDATE_HOUSEHOLD_FAIL,
  payload: error,
})

export const getTrainingSubjects = (active = false) => ({
  type: GET_TRAININGSUBJECTS,
  payload: active,
})

export const getTrainingSubjectsSuccess = trainingsubjects => ({
  type: GET_TRAININGSUBJECTS_SUCCESS,
  payload: trainingsubjects,
})

export const getTrainingSubjectsFail = error => ({
  type: GET_TRAININGSUBJECTS_FAIL,
  payload: error,
})

export const getTrainingTypes = () => ({
  type: GET_TRAININGTYPES,
})

export const getTrainingTypesSuccess = trainingtypes => ({
  type: GET_TRAININGTYPES_SUCCESS,
  payload: trainingtypes,
})

export const getTrainingTypesFail = error => ({
  type: GET_TRAININGTYPES_FAIL,
  payload: error,
})

export const getTrainingMonths = () => ({
  type: GET_TRAININGMONTHS,
})

export const getTrainingMonthsSuccess = trainingmonths => ({
  type: GET_TRAININGMONTHS_SUCCESS,
  payload: trainingmonths,
})

export const getTrainingMonthsFail = error => ({
  type: GET_TRAININGMONTHS_FAIL,
  payload: error,
})

export const addHouseholdFileUpload = file => ({
  type: ADD_HOUSEHOLD_FILEUPLOAD,
  payload: file,
})

export const addHouseholdFileUploadSuccess = result => ({
  type: ADD_HOUSEHOLD_FILEUPLOAD_SUCCESS,
  payload: result,
})

export const addHouseholdFileUploadFail = error => ({
  type: ADD_HOUSEHOLD_FILEUPLOAD_FAIL,
  payload: error,
})
export const addHouseholdDataUpload = () => ({
  type: ADD_HOUSEHOLD_DATAUPLOAD,
})

export const addHouseholdDataUploadSuccess = data => ({
  type: ADD_HOUSEHOLD_DATAUPLOAD_SUCCESS,
  payload: data,
})

export const addHouseholdDataUploadFail = error => ({
  type: ADD_HOUSEHOLD_DATAUPLOAD_FAIL,
  payload: error,
})

export const getSubjectDetail = rowID => ({
  type: GET_SUBJECT_DETAIL,
  rowID,
})

export const getSubjectDetailSuccess = details => ({
  type: GET_SUBJECT_DETAIL_SUCCESS,
  payload: details,
})

export const getSubjectDetailFail = error => ({
  type: GET_SUBJECT_DETAIL_FAIL,
  payload: error,
})

export const addSubject = subject => ({
  type: ADD_SUBJECT,
  payload: subject,
})

export const addSubjectSuccess = subject => ({
  type: ADD_SUBJECT_SUCCESS,
  payload: subject,
})

export const addSubjectFail = error => ({
  type: ADD_SUBJECT_FAIL,
  payload: error,
})

export const updateSubject = subject => ({
  type: UPDATE_SUBJECT,
  payload: subject,
})

export const updateSubjectSuccess = subject => ({
  type: UPDATE_SUBJECT_SUCCESS,
  payload: subject,
})

export const updateSubjectFail = error => ({
  type: UPDATE_SUBJECT_FAIL,
  payload: error,
})
